import { useLazyQuery, useMutation } from "react-apollo";
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Button,
  Progress,
  Label,
  Card,
  Table,
} from "reactstrap";
import { GET_REBATE } from "../../graphql/query/GET_REBATE";
import InfiniteScroll from "react-infinite-scroll-component";
import { Link } from "react-router-dom";
import classnames from "classnames";
import _ from "lodash";
import { RELEASE_ONE_REBATE } from "../../graphql/mutation/RELEASE_ONE_REBATE";
import { RELEASE_ALL_REBATE } from "../../graphql/mutation/RELEASE_ALL_REBATE";
import RebateGameAccount from "./rebate-game-account";
import moment from "moment";

function RebateDetails(props) {
  const { modal, toggleModal, rebate } = props;

  const [getRebate, { data: rebateData, fetchMore }] = useLazyQuery(GET_REBATE);
  const [releaseRebateItem] = useMutation(RELEASE_ONE_REBATE);
  const [releaseAllRebate, { loading: loadingReleaseAllRebate }] =
    useMutation(RELEASE_ALL_REBATE);
  const [orderBy, setOrderBy] = useState("createdAt");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const [selectedPlayer, setSelectedPlayer] = useState(null);

  useEffect(() => {
    if (rebate) {
      getRebate({
        variables: { id: rebate?.id, after: null },
        fetchPolicy: "network-only",
      });
    }
  }, [rebate]);

  useEffect(() => {
    if (rebateData && rebate) {
      setTimeout(() => {
        if (rebateData?.rebate?.rebateItems.pageInfo.hasNextPage) {
          fetchMore({
            variables: {
              id: rebate?.id,
              after: rebateData?.rebate?.rebateItems.pageInfo.endCursor,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              if (fetchMoreResult.rebate.id !== rebate.id) {
                return previousResult;
              }

              const newEdges = fetchMoreResult.rebate.rebateItems.edges;
              const pageInfo = fetchMoreResult.rebate.rebateItems.pageInfo;

              return newEdges.length
                ? {
                  rebate: {
                    ...previousResult.rebate,
                    rebateItems: {
                      ...previousResult.rebate.rebateItems,
                      edges: _.uniq([
                        ...previousResult.rebate.rebateItems.edges,
                        ...newEdges,
                      ]),
                      pageInfo,
                    },
                  },
                }
                : previousResult;
            },
          });
        }
      }, 1000);
    }
  }, [rebateData]);

  const OrderBy = (type) => {
    if (orderBy === type) {
      if (orderDirection === "ASC") {
        setOrderDirection("DESC");
      } else {
        setOrderDirection("ASC");
      }
    } else {
      setOrderDirection("ASC");
      setOrderBy(type);
    }
  };

  const Header = (props) => {
    const { type, className, name } = props;

    return (
      <th
        className={`cursor-pointer ${className}`}
        onClick={() => OrderBy(type)}
      >
        <div
          className={classnames({
            "align-center": orderBy === type,
          })}
        >
          <div>{name}</div>
        </div>
      </th>
    );
  };

  return (
    <React.Fragment>
      <Modal
        isOpen={modal}
        role="dialog"
        size="lg"
        autoFocus={true}
        centered={true}
        id="verificationModal"
        tabIndex="-1"
        toggle={toggleModal}
        style={{ maxWidth: "1200px" }}
      >
        <ModalHeader toggle={toggleModal}>Rebate Details</ModalHeader>
        <ModalBody>
          <Card>
            <InfiniteScroll
              dataLength={rebateData?.rebate?.rebateItems.edges.length ?? 0} //This is important field to render the next data
              hasMore={rebateData?.rebate?.rebateItems.pageInfo.hasNextPage}
              loader={
                <div className="text-center my-3">
                  <Link to="#" className="text-success">
                    <i className="bx bx-hourglass bx-spin mr-2"></i> Load more{" "}
                  </Link>
                </div>
              }
              endMessage={
                <div className="text-center my-3">
                  <div>Yay! You have seen it all</div>
                </div>
              }
            >
              <div className="table-responsive">
                <Table className="table mb-0">
                  <thead>
                    <tr className="font-size-12">
                      <th>#</th>
                      <Header name="Serial No" className="" />
                      <Header name="Player Name" className="" />
                      <Header name="Total Deposit" className="" type="" />
                      <Header name="Total Withdraw" className="" type="" />
                      <Header name="Total Bonus" className="" type="" />
                      <Header name="Total Rebate" className="" type="" />
                      <Header name="Game Details" className="" type="" />
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className="table-body">
                    {rebateData &&
                      rebateData?.rebate?.rebateItems.edges.map(
                        (rebateItem, key) => (
                          <tr>
                            <td>{key + 1}</td>
                            <td
                              style={{
                                display: "flex",
                              }}
                            >
                              <i
                                className="bx bxs-wrench font-size-18 mr-2"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  const user = JSON.stringify({
                                    user: {
                                      node: {
                                        serialNo:
                                          rebateItem.node.player.serialNo,
                                        username:
                                          rebateItem.node.player.username,
                                        phoneNo: rebateItem.node.player.phoneNo,
                                        id: rebateItem.node.player.id,
                                      },
                                    },
                                  });

                                  window.localStorage.setItem(
                                    "workbench-state",
                                    user
                                  );
                                  window.open("/cashier-workbench", "_blank");
                                }}
                              ></i>
                              {rebateItem.node.player.serialNo}
                            </td>
                            <td
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => {
                                setSelectedPlayer(rebateItem.node.player);
                              }}
                            >
                              {rebateItem.node.player.name}
                            </td>
                            <td>
                              {parseFloat(rebateItem.node.totalDeposit).toFixed(
                                2
                              )}
                            </td>
                            <td>
                              {parseFloat(
                                rebateItem.node.totalWithdrawal
                              ).toFixed(2)}
                            </td>
                            <td>
                              {parseFloat(rebateItem.node.totalBonus).toFixed(
                                2
                              )}
                            </td>
                            <td>{`${parseFloat(
                              rebateItem.node.rebateAmount
                            ).toFixed(2)} (${rebateItem.node.rebatePercentage * 100
                              }%)`}</td>
                            <td>
                              <div>
                                {rebateItem.node.lastGameAccount?.username}
                                {rebateItem.node.lastGameAccount?.kioskAccount?.platform?.name}
                              </div>
                            </td>
                            <td
                              style={{
                                justifyItems: "end",
                              }}
                            >
                              <div className="d-flex">
                                <div
                                  className="cursor-pointer"
                                  style={{
                                    justifyItems: "end",
                                  }}
                                >
                                  <div
                                    className={`btn-primary rebate-button ${!_.isEmpty(rebateItem.node.releasedAt)
                                      ? "disabled"
                                      : ""
                                      }`}
                                    onClick={() => {
                                      if (
                                        !_.isEmpty(rebateItem.node.releasedAt)
                                      ) {
                                        return;
                                      }
                                      releaseRebateItem({
                                        variables: {
                                          id: rebateItem.node.id,
                                        },
                                      });
                                    }}
                                  >
                                    {_.isEmpty(rebateItem.node.releasedAt)
                                      ? "Release"
                                      : "Released"}
                                  </div>
                                  {!_.isEmpty(rebateItem.node.releasedAt) && (
                                    <div
                                      style={{
                                        textAlign: "right",
                                      }}
                                    >
                                      {moment(
                                        rebateItem.node.releasedAt
                                      ).format("YYYY-MM-DD HH:mm:ss")}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </td>
                          </tr>
                        )
                      )}
                    {rebateData &&
                      rebateData?.rebate?.rebateItems.edges.length === 0 && (
                        <tr className="text-center pt-3">
                          <td colSpan={12}>{"No Rebate Item Found"}</td>
                        </tr>
                      )}
                  </tbody>
                </Table>
              </div>
            </InfiniteScroll>
          </Card>
          <div className="d-flex justify-content-end">
            <Button
              disabled={
                (rebateData &&
                  (!rebateData?.rebate?.rebateItems.edges.filter((rebateItem) =>
                    _.isEmpty(rebateItem.node.releasedAt)
                  ).length > 0 ||
                    rebateData?.rebate?.rebateItems.edges.length === 0)) ||
                loadingReleaseAllRebate
              }
              color="primary"
              style={{ marginBottom: "10px" }}
              onClick={() => {
                releaseAllRebate({
                  variables: {
                    id: rebate?.id,
                  },
                }).then(() => {
                  getRebate({
                    variables: { id: rebate?.id, after: null },
                    fetchPolicy: "network-only",
                  });
                });
              }}
            >
              Release All
              {loadingReleaseAllRebate && (
                <i className="bx bx-loader-alt bx-spin ml-2"></i>
              )}
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <RebateGameAccount
        player={selectedPlayer}
        toggleModal={() => setSelectedPlayer(null)}
      />
    </React.Fragment>
  );
}

export default RebateDetails;
